var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill With Left Arrow"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#18173C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons:arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 16L15 23L22 30M15 23H31",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.7d2c5638773a8c5b442c58a236c0c4d9.svg";
export { ForwardRef as ReactComponent };